import { css } from 'linaria';
import { styled } from 'linaria/react';

export const ProductTitleContainer = styled.div`
  margin: 0 0 var(--space-50) 0;
`;

export const TitleWithWishlist = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: var(--space-400);
`;

export const SkeletonRows = styled.div`
  display: flex;
  flex-direction: column;
`;

export const skuSkeleton = css`
  border-radius: var(--rounding-l);
  margin-bottom: var(--space-200);
`;

export const titleSkeleton = css`
  border-radius: var(--rounding-l);
`;
